import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type BulkUploadService = {
  __typename?: 'BulkUploadService';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  referrerDescription?: Maybe<Scalars['String']['output']>;
};

export type CreateBatchReferralResponse = {
  __typename?: 'CreateBatchReferralResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateBatchReferralsInput = {
  clinicianId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  referrals: Array<CreateReferralInput>;
};

export type CreateReferralInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateReferralUploadJobInput = {
  fileName: Scalars['String']['input'];
  rows: Array<ReferralUploadRowInput>;
  serviceCode: Scalars['String']['input'];
};

export type GetOrgStatsInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetOrgStatsResponse = {
  __typename?: 'GetOrgStatsResponse';
  accountCreatedCount: Scalars['Int']['output'];
  cancelledCount: Scalars['Int']['output'];
  completionRatePercentage?: Maybe<Scalars['Float']['output']>;
  expiredCount: Scalars['Int']['output'];
  inviteCount: Scalars['Int']['output'];
  reportsCompletedCount: Scalars['Int']['output'];
};

export type GetReferralSessionFilters = {
  fromCompletedDate?: InputMaybe<Scalars['Date']['input']>;
  fromReferralDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  showCompletedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  toCompletedDate?: InputMaybe<Scalars['Date']['input']>;
  toReferralDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetReferralSessionsInput = {
  filters?: InputMaybe<GetReferralSessionFilters>;
  pagedQuery?: InputMaybe<PagedQuery>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortParams>;
};

export type GetReferralSessionsResponse = {
  __typename?: 'GetReferralSessionsResponse';
  sessions: Array<ReferralSession>;
  totalCount: Scalars['Int']['output'];
};

export type GetReferralUploadJobsInput = {
  pagedQuery?: InputMaybe<PagedQuery>;
};

export type GetReferralUploadJobsResponse = {
  __typename?: 'GetReferralUploadJobsResponse';
  jobs: Array<ReferralUploadJob>;
  totalCount: Scalars['Int']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  respondentType: RespondentType;
  serviceUserLink: Scalars['String']['output'];
  status: InviteStatus;
};

export enum InviteStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export type Mutation = {
  __typename?: 'Mutation';
  createBatchReferrals: CreateBatchReferralResponse;
  createReferralUploadJob: ReferralUploadJob;
};


export type MutationCreateBatchReferralsArgs = {
  batchReferralsInput: CreateBatchReferralsInput;
};


export type MutationCreateReferralUploadJobArgs = {
  input: CreateReferralUploadJobInput;
};

export type OrganisationServicesResponse = {
  __typename?: 'OrganisationServicesResponse';
  services: Array<Service>;
};

export type PagedQuery = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Patient = {
  __typename?: 'Patient';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  piSystemId: PiSystemId;
};

export type PiSystemId = {
  __typename?: 'PiSystemId';
  id: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getOrgStats: GetOrgStatsResponse;
  getOrganisationServices: OrganisationServicesResponse;
  getReferralSessions: GetReferralSessionsResponse;
  getReferralUploadJobs: GetReferralUploadJobsResponse;
  getServiceForUpload: Service;
  getServicesForUpload: Array<BulkUploadService>;
};


export type QueryGetOrgStatsArgs = {
  input: GetOrgStatsInput;
};


export type QueryGetReferralSessionsArgs = {
  input: GetReferralSessionsInput;
};


export type QueryGetReferralUploadJobsArgs = {
  input: GetReferralUploadJobsInput;
};


export type QueryGetServiceForUploadArgs = {
  serviceCode: Scalars['String']['input'];
};

export type Referral = {
  __typename?: 'Referral';
  id: Scalars['ID']['output'];
  patient: Patient;
  service: Service;
};

export type ReferralSession = {
  __typename?: 'ReferralSession';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invites: Array<Invite>;
  referral: Referral;
  reportAvailable?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
};

export enum ReferralSortField {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  PiSystemId = 'piSystemId',
  Status = 'status'
}

export type ReferralUploadJob = {
  __typename?: 'ReferralUploadJob';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  erroredRows: Array<ReferralUploadJobErroredRow>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rowCount: Scalars['Int']['output'];
  service: Service;
  statusCounts: ReferralUploadJobRowStatusCounts;
};

export type ReferralUploadJobErroredRow = {
  __typename?: 'ReferralUploadJobErroredRow';
  eprId: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type ReferralUploadJobRowStatusCounts = {
  __typename?: 'ReferralUploadJobRowStatusCounts';
  created: Scalars['Int']['output'];
  errored: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

export type ReferralUploadRowContactInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  respondentType: RespondentType;
};

export type ReferralUploadRowInput = {
  careTeam?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ReferralUploadRowContactInput>>;
  eprId: Scalars['String']['input'];
  eprSystem: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  healthCareSystemId?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  rowNumber: Scalars['Int']['input'];
};

export enum RespondentType {
  Carer = 'carer',
  Informant1 = 'informant1',
  Patient = 'patient'
}

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortParams = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ReferralSortField>;
};

export type GetReferralUploadJobsQueryVariables = Exact<{
  input: GetReferralUploadJobsInput;
}>;


export type GetReferralUploadJobsQuery = { __typename?: 'Query', getReferralUploadJobs: { __typename?: 'GetReferralUploadJobsResponse', totalCount: number, jobs: Array<{ __typename?: 'ReferralUploadJob', id: string, fileName: string, rowCount: number, createdAt: any, createdBy: string, service: { __typename?: 'Service', code: string, description: string }, statusCounts: { __typename?: 'ReferralUploadJobRowStatusCounts', pending: number, created: number, errored: number }, erroredRows: Array<{ __typename?: 'ReferralUploadJobErroredRow', id: string, rowNumber: number, eprId: string, givenName: string, familyName: string, errorMessage: string }> }> } };

export type CreateReferralUploadJobMutationVariables = Exact<{
  input: CreateReferralUploadJobInput;
}>;


export type CreateReferralUploadJobMutation = { __typename?: 'Mutation', createReferralUploadJob: { __typename?: 'ReferralUploadJob', id: string, fileName: string, rowCount: number, createdAt: any, createdBy: string } };

export type GetServiceForUploadQueryVariables = Exact<{
  serviceCode: Scalars['String']['input'];
}>;


export type GetServiceForUploadQuery = { __typename?: 'Query', getServiceForUpload: { __typename?: 'Service', code: string, description: string } };

export type GetServicesForUploadQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServicesForUploadQuery = { __typename?: 'Query', getServicesForUpload: Array<{ __typename?: 'BulkUploadService', code: string, description: string, referrerDescription?: string | null }> };


export const GetReferralUploadJobsDocument = gql`
    query GetReferralUploadJobs($input: GetReferralUploadJobsInput!) {
  getReferralUploadJobs(input: $input) {
    totalCount
    jobs {
      id
      service {
        code
        description
      }
      fileName
      rowCount
      statusCounts {
        pending
        created
        errored
      }
      erroredRows {
        id
        rowNumber
        eprId
        givenName
        familyName
        errorMessage
      }
      createdAt
      createdBy
    }
  }
}
    `;

export function useGetReferralUploadJobsQuery(options: Omit<Urql.UseQueryArgs<GetReferralUploadJobsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReferralUploadJobsQuery, GetReferralUploadJobsQueryVariables>({ query: GetReferralUploadJobsDocument, ...options });
};
export const CreateReferralUploadJobDocument = gql`
    mutation CreateReferralUploadJob($input: CreateReferralUploadJobInput!) {
  createReferralUploadJob(input: $input) {
    id
    fileName
    rowCount
    createdAt
    createdBy
  }
}
    `;

export function useCreateReferralUploadJobMutation() {
  return Urql.useMutation<CreateReferralUploadJobMutation, CreateReferralUploadJobMutationVariables>(CreateReferralUploadJobDocument);
};
export const GetServiceForUploadDocument = gql`
    query GetServiceForUpload($serviceCode: String!) {
  getServiceForUpload(serviceCode: $serviceCode) {
    code
    description
  }
}
    `;

export function useGetServiceForUploadQuery(options: Omit<Urql.UseQueryArgs<GetServiceForUploadQueryVariables>, 'query'>) {
  return Urql.useQuery<GetServiceForUploadQuery, GetServiceForUploadQueryVariables>({ query: GetServiceForUploadDocument, ...options });
};
export const GetServicesForUploadDocument = gql`
    query GetServicesForUpload {
  getServicesForUpload {
    code
    description
    referrerDescription
  }
}
    `;

export function useGetServicesForUploadQuery(options?: Omit<Urql.UseQueryArgs<GetServicesForUploadQueryVariables>, 'query'>) {
  return Urql.useQuery<GetServicesForUploadQuery, GetServicesForUploadQueryVariables>({ query: GetServicesForUploadDocument, ...options });
};